import { useMemo } from 'react';
import { useAuthStore } from '../store/authStore';

export function useUserSegmentScope() {
  const user = useAuthStore((s) => s.user);

  return useMemo(() => {
    const assignedSegmentIds = user?.customerSegmentIds ?? [];
    const isScoped = assignedSegmentIds.length > 0;

    const defaultSegmentIdsForApi = (selected?: string[]): string[] => {
      if (!isScoped) {
        return selected ?? [];
      }
      if (selected && selected.length > 0) {
        return selected.filter((id) => assignedSegmentIds.includes(id));
      }
      return [...assignedSegmentIds];
    };

    return {
      isScoped,
      assignedSegmentIds,
      defaultSegmentIdsForApi,
    };
  }, [user?.customerSegmentIds]);
}
